@if (!isMobileScreen()) {
    <div class="flex flex-row justify-center md:justify-end text-xs w-full bg-ponder-light text-slate-50 text-opacity-90 p-1 pr-2 sm:rounded-b-md shadow-lg sm:shadow gap-2 border-r-2 border-ponder-light">
        <div>
            Total Value:
        </div>
        <div>
            {{ getCurrentLayerValue() }}
        </div>
        @if (isAuthed) {
            <div class="opacity-75">
                |
            </div>
            <div>
                Collected:
            </div>
            <div>
                {{ getCurrentLayerCollectedCount() }} cards
            </div>
            <div>
                {{ getCurrentLayerCollectedValue() }}
            </div>
        }
    </div>
} @else {
    <div class="flex flex-row items-center text-xs gap-1 text-slate-200">
        <div>
            {{ getCurrentLayerValue() }}
        </div>
        @if (isAuthed) {
            <div class="opacity-75">
                |
            </div>
            <div>
                Collected:
            </div>
            <div>
                {{ getCurrentLayerCollectedCount() }} cards
            </div>
            <div>
                {{ getCurrentLayerCollectedValue() }}
            </div>
        }
    </div>
}